import NotificationService from '@/libs/core/notifications/notification-service';
import { Plugin } from 'vuex';
import { createStoreAction } from '@/libs/core/+state/functions/create-store-action';
import { createStoreGetter } from '@/libs/core/+state/functions/create-store-getter';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { CrudEntity } from '@/libs/core/+state/models/crud-service';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { BusinessModule } from '@/libs/core/models/business-module';
import globalStore from '@/libs/core/+state/store';
import { PredicateBuilder } from '../functions/predicate-builder';
import ApiService from '@/libs/core/api-service';
import moment from 'moment';
import { ApiResultFailed, EventList, HttpResponse } from '@/libs/Api';
import { Notification } from '@/libs/core/notifications/models/notification';
import { BasicEventTypeEnum } from '@/libs/core/notifications/models/notification-event-type';

export function createNotificationPlugin(): Plugin<any> {
    const getStore = (storeName: BusinessModule) => ({
        action: createStoreAction(storeName),
        getter: createStoreGetter(storeName),
    });

    return (store) => {
        NotificationService.created.subscribe({
            next: (notification) => {
                const state = globalStore.state as any;
                if (state[notification.objectType] && state[notification.objectType].data) {
                    Object.keys(state[notification.objectType].data).forEach((e: string) => {
                        if (state[notification.objectType].dataQuery[e]) {
                            const query = state[notification.objectType].dataQuery[e].data.predicates;
                            try {
                                if (query.length == 0 || PredicateBuilder.GetExpression(query)(notification.item)) {
                                    const store = getStore(notification.objectType);
                                    store
                                        .action(CrudAction.GetAll, {
                                            key: e,
                                            query: 'same',
                                            extra: {
                                                ignoreKeySuffix: true,
                                                command: notification.command,
                                            },
                                        })
                                        .then();
                                }
                            } catch (ex) {
                                const store = getStore(notification.objectType);
                                store
                                    .action(CrudAction.GetAll, {
                                        key: e,
                                        query: 'same',
                                        extra: {
                                            ignoreKeySuffix: true,
                                            command: notification.command,
                                        },
                                    })
                                    .then();
                            }
                        }
                    });
                    Object.keys(state[notification.objectType].dataBasic).forEach((e: string) => {
                        if (state[notification.objectType].dataBasicQuery[e]) {
                            const query = state[notification.objectType].dataBasicQuery[e].data.predicates;
                            try {
                                if (query.length == 0 || PredicateBuilder.GetExpression(query)(notification.item)) {
                                    const store = getStore(notification.objectType);
                                    store
                                        .action(CrudAction.GetAllBasic, {
                                            key: e,
                                            query: 'same',
                                            extra: {
                                                ignoreKeySuffix: true,
                                                command: notification.command,
                                            },
                                        })
                                        .then();
                                }
                            } catch (ex) {
                                const store = getStore(notification.objectType);
                                store
                                    .action(CrudAction.GetAllBasic, {
                                        key: e,
                                        query: 'same',
                                        extra: {
                                            ignoreKeySuffix: true,
                                            command: notification.command,
                                        },
                                    })
                                    .then();
                            }
                        }
                    });
                }
            },
            complete() {
                console.log('STORE NOTIFICATION', 'CREATED COMPLETE');
            },
            error(err: any) {
                console.error('STORE NOTIFICATION CREATED ERROR', err);
            },
        });

        NotificationService.updated.subscribe({
            next: (notification) => {
                const store = getStore(notification.objectType);
                store.action(CrudAction.PartialUpdate, {
                    id: notification.objectId,
                    key: notification.objectId,
                    diff: notification.diff,
                    item: notification.item,
                    extra: {
                        local: true,
                        ignoreKeySuffix: true,
                        command: notification.command,
                    },
                });
            },
            complete() {
                console.log('STORE NOTIFICATION', 'UPDATE COMPLETE');
            },
            error(err: any) {
                console.error('STORE NOTIFICATION UPDATE ERROR', err);
            },
        });

        NotificationService.deleted.subscribe({
            next: (notification) => {
                const store = getStore(notification.objectType);
                store.action(CrudAction.Delete, {
                    id: notification.objectId,
                    key: notification.objectId,
                    data: [{ id: notification.objectId }],
                    extra: {
                        local: true,
                        ignoreKeySuffix: true,
                        command: notification.command,
                    },
                });
            },
            complete() {
                console.log('STORE NOTIFICATION', 'DELETE COMPLETE');
            },
            error(err: any) {
                console.error('STORE NOTIFICATION DELETE ERROR', err);
            },
        });

        NotificationService.reconnected.subscribe({
            next(syncTime: number) {
                /*const state = globalStore.state as any;
                let n = 0;
                for (const objectType in state) {
                    //console.log('STORE NOTIFICATION', 'RECONNECT', 'DATA', state[objectType].data);
                    //console.log('STORE NOTIFICATION', 'RECONNECT', 'BASIC', state[objectType].dataBasic);
                    for (const key in state[objectType].data) {
                        if (state[objectType].dataQuery[key]) {
                            console.log('STORE NOTIFICATION', 'RECONNECT', objectType, key, 'DATA', ++n);
                        }
                    }
                    for (const key in state[objectType].dataBasic) {
                        if (state[objectType].dataBasicQuery[key]) {
                            console.log('STORE NOTIFICATION', 'RECONNECT', objectType, key, 'BASIC', ++n);
                        }
                    }
                    for (const key in state[objectType].detail) {
                        console.log('STORE NOTIFICATION', 'RECONNECT', objectType, key, 'DETAIL', ++n);
                    }
                }*/
                ApiService.api
                    .getSignalNotificationBatch({
                        fromDate: moment(syncTime).toISOString(),
                    })
                    .then(async (response: HttpResponse<EventList, ApiResultFailed | void>) => {
                        const state = globalStore.state as any;
                        const keysToRefresh: Dictionary<string[]> = {};
                        const basicKeysToRefresh: Dictionary<string[]> = {};
                        for (const x of response.data.items!) {
                            const parsedEvent = JSON.parse(x.data!) as Notification;
                            if (!NotificationService.popCorrelationId(parsedEvent.correlationId)) {
                                const store = getStore(parsedEvent.objectType);
                                if (store) {
                                    switch (x.eventType) {
                                        case BasicEventTypeEnum.ObjectAdded:
                                            Object.keys(state[parsedEvent.objectType].data).forEach((e: string) => {
                                                if (state[parsedEvent.objectType].dataQuery[e]) {
                                                    const query = state[parsedEvent.objectType].dataQuery[e].data.predicates;
                                                    if (
                                                        query.length == 0 ||
                                                        PredicateBuilder.GetExpression(query)(parsedEvent.item)
                                                    ) {
                                                        if (!keysToRefresh[parsedEvent.objectType]) {
                                                            keysToRefresh[parsedEvent.objectType] = [] as string[];
                                                        }
                                                        keysToRefresh[parsedEvent.objectType].push(e);
                                                    }
                                                }
                                            });
                                            Object.keys(state[parsedEvent.objectType].dataBasic).forEach((e: string) => {
                                                if (state[parsedEvent.objectType].dataBasicQuery[e]) {
                                                    const query =
                                                        state[parsedEvent.objectType].dataBasicQuery[e].data.predicates;
                                                    if (
                                                        query.length == 0 ||
                                                        PredicateBuilder.GetExpression(query)(parsedEvent.item)
                                                    ) {
                                                        if (!keysToRefresh[parsedEvent.objectType]) {
                                                            basicKeysToRefresh[parsedEvent.objectType] = [] as string[];
                                                        }
                                                        basicKeysToRefresh[parsedEvent.objectType].push(e);
                                                    }
                                                }
                                            });
                                            break;
                                        case BasicEventTypeEnum.ObjectUpdated:
                                            await store.action(CrudAction.PartialUpdate, {
                                                id: parsedEvent.objectId,
                                                key: parsedEvent.objectId,
                                                diff: parsedEvent.diff,
                                                item: parsedEvent.item,
                                                extra: {
                                                    local: true,
                                                    ignoreKeySuffix: true,
                                                    command: parsedEvent.command,
                                                },
                                            });
                                            break;
                                        case BasicEventTypeEnum.ObjectDeleted:
                                            await store.action(CrudAction.Delete, {
                                                id: parsedEvent.objectId,
                                                key: parsedEvent.objectId,
                                                data: [{ id: parsedEvent.objectId }],
                                                extra: {
                                                    local: true,
                                                    ignoreKeySuffix: true,
                                                    command: parsedEvent.command,
                                                },
                                            });
                                            break;
                                    }
                                }
                            }
                        }
                        for (const objectType in keysToRefresh) {
                            const store = getStore(objectType as BusinessModule);
                            for (const key of keysToRefresh[objectType]) {
                                store
                                    .action(CrudAction.GetAll, {
                                        key: key,
                                        query: 'same',
                                        extra: {
                                            ignoreKeySuffix: true,
                                            command: null,
                                        },
                                    })
                                    .then();
                            }
                        }
                        for (const objectType in basicKeysToRefresh) {
                            const store = getStore(objectType as BusinessModule);
                            for (const key of basicKeysToRefresh[objectType]) {
                                store
                                    .action(CrudAction.GetAllBasic, {
                                        key: key,
                                        query: 'same',
                                        extra: {
                                            ignoreKeySuffix: true,
                                            command: null,
                                        },
                                    })
                                    .then();
                            }
                        }
                    });
            },
            complete() {
                console.log('STORE NOTIFICATION', 'RECONNECT COMPLETE');
            },
            error(err: any) {
                console.error('STORE NOTIFICATION RECONNECT ERROR', err);
            },
        });
    };
}
